import { RemoteVideoTrack } from "twilio-video";
import { RemoteVideoDelegator } from "../../../../core/room/participant/media/MediaDelegator";
import {
  MediaSource,
  QualityMode,
} from "../../../../core/room/participant/media/types";
import { deserializeMediaMetadata } from "../../../../core/room/participant/media/utils";
import { detachRemoteTrack } from "./utils";

export class TwilioRemoteVideoDelegator implements RemoteVideoDelegator {
  readonly kind = "video" as const;

  #track: RemoteVideoTrack;
  #source: MediaSource;
  #qualityMode: QualityMode | undefined;

  constructor(videoTrack: RemoteVideoTrack) {
    this.#track = videoTrack;

    const { source, qualityMode } = deserializeMediaMetadata(
      videoTrack.name,
      videoTrack.kind,
    );

    if (source === "screen") {
      this.#source = MediaSource.Screen;
    } else {
      this.#source = MediaSource.Camera;
    }
    this.#qualityMode = qualityMode;
  }

  get sid() {
    return this.#track.sid;
  }

  get source() {
    return this.#source;
  }

  get isEnabled() {
    return this.#track.isEnabled;
  }

  get qualityMode() {
    return this.#qualityMode;
  }

  async attach(element: HTMLVideoElement) {
    this.#track.attach(element);
  }

  async detach(element: HTMLVideoElement) {
    if (element) {
      detachRemoteTrack({ track: this.#track, element });
    }
  }

  // Not part of the interface, used for backwards compatibility
  get track() {
    return this.#track;
  }
}
